/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BulkPlaceholderAllocationsInput = {
    placeholderAllocations?: Array<PlaceholderAllocationInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type PlaceholderAllocationInputType = {
    id?: string | null | undefined;
    startDate?: string | null | undefined;
    endDate?: string | null | undefined;
    placeholderId?: string | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    description?: string | null | undefined;
};
export type bulkPlaceholderAllocationsMutationVariables = {
    input: BulkPlaceholderAllocationsInput;
};
export type bulkPlaceholderAllocationsMutationResponse = {
    readonly bulkPlaceholderAllocations: {
        readonly placeholderAllocations: ReadonlyArray<{
            readonly id: string;
            readonly placeholder: {
                readonly id: string;
            } | null;
            readonly description: string | null;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly monday: number | null;
            readonly tuesday: number | null;
            readonly wednesday: number | null;
            readonly thursday: number | null;
            readonly friday: number | null;
            readonly saturday: number | null;
            readonly sunday: number | null;
        } | null> | null;
    } | null;
};
export type bulkPlaceholderAllocationsMutation = {
    readonly response: bulkPlaceholderAllocationsMutationResponse;
    readonly variables: bulkPlaceholderAllocationsMutationVariables;
};



/*
mutation bulkPlaceholderAllocationsMutation(
  $input: BulkPlaceholderAllocationsInput!
) {
  bulkPlaceholderAllocations(input: $input) {
    placeholderAllocations {
      id
      placeholder {
        id
      }
      description
      startDate
      endDate
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "BulkPlaceholderAllocationsInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkPlaceholderAllocationsPayload",
    "kind": "LinkedField",
    "name": "bulkPlaceholderAllocations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlaceholderAllocation",
        "kind": "LinkedField",
        "name": "placeholderAllocations",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Placeholder",
            "kind": "LinkedField",
            "name": "placeholder",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "friday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sunday",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkPlaceholderAllocationsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkPlaceholderAllocationsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "bulkPlaceholderAllocationsMutation",
    "operationKind": "mutation",
    "text": "mutation bulkPlaceholderAllocationsMutation(\n  $input: BulkPlaceholderAllocationsInput!\n) {\n  bulkPlaceholderAllocations(input: $input) {\n    placeholderAllocations {\n      id\n      placeholder {\n        id\n      }\n      description\n      startDate\n      endDate\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1315f250df26ddb96ad772b70c5bc519';
export default node;
